import { IConfiguredAddon } from 'src/types/aggregator.types';
import { codeOf } from '../useTimetablePublishDestinations/canReceiveTimetable';

/**
 * A Menu Set publishes as one ordinary menu, so the handler resolves `export_menu` exactly as Menu
 * publish does. Mirrors its ENDPOINT_NOT_FOUND, ENDPOINT_DISABLED and UrlNotConfigured checks.
 */
export const canReceiveMenuSet = ({ endpoints }: IConfiguredAddon): boolean =>
  endpoints.some(
    (endpoint) => codeOf(endpoint) === 'export_menu' && endpoint.isEnabled && Boolean(endpoint.endpointUrl),
  );
